exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--opacity__8S75s{opacity:1}:hover>.styles--opacity__8S75s,.styles--opacityInversed__3e0jn{opacity:0.7}:hover>.styles--opacityInversed__3e0jn{opacity:1}\n", ""]);

// exports
exports.locals = {
	"opacity": "styles--opacity__8S75s",
	"opacityInversed": "styles--opacityInversed__3e0jn"
};